var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383D5B",
    d: "M24.9,-37.6C39.1,-35,62.2,-42.1,69.5,-37.5C76.9,-32.8,68.5,-16.4,63.4,-3C58.3,10.5,56.4,21,51,29C45.6,36.9,36.6,42.3,27.5,43.5C18.4,44.7,9.2,41.6,-3.2,47.1C-15.5,52.6,-31.1,66.7,-39.5,65.1C-47.9,63.6,-49.2,46.4,-51.3,32.9C-53.4,19.4,-56.3,9.7,-61,-2.8C-65.8,-15.2,-72.5,-30.4,-68.9,-41.3C-65.3,-52.2,-51.5,-58.7,-38.3,-61.9C-25.1,-65.1,-12.5,-64.9,-3.6,-58.7C5.4,-52.5,10.7,-40.2,24.9,-37.6Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayBlob);
export default __webpack_public_path__ + "static/media/overlay_blob.88e7cd9323ff39ef6827a3b816131893.svg";
export { ForwardRef as ReactComponent };